import Model from './BaseModel';
import Race from './Race';

export default class Price extends Model {
	resourceName() {
		return 'prices';
	}

	fields() {
		return ['price', 'product', 'bet_type'];
	}

	relationships() {
		return {
			race: new Race()
		};
	}
}
